export default function TwoPeopleIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.6667 27.9999V25.3333C30.6658 24.1516 30.2725 23.0036 29.5485 22.0697C28.8245 21.1358 27.8109 20.4687 26.6667 20.1733"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6666 28V25.3333C22.6666 23.9188 22.1047 22.5623 21.1045 21.5621C20.1044 20.5619 18.7478 20 17.3333 20H6.66665C5.25216 20 3.8956 20.5619 2.89541 21.5621C1.89522 22.5623 1.33331 23.9188 1.33331 25.3333V28"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 4.17331C22.4805 4.46704 23.4974 5.13424 24.2235 6.06972C24.9496 7.0052 25.3438 8.15575 25.3438 9.33998C25.3438 10.5242 24.9496 11.6747 24.2235 12.6102C23.4974 13.5457 22.4805 14.2129 21.3333 14.5066"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.6667C14.9455 14.6667 17.3334 12.2789 17.3334 9.33333C17.3334 6.38781 14.9455 4 12 4C9.0545 4 6.66669 6.38781 6.66669 9.33333C6.66669 12.2789 9.0545 14.6667 12 14.6667Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
